import React from 'react';
import PropTypes from 'prop-types';
import { Button,CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export const OutlineButton = ({
  text,
  onClickHandler,
  color,
  borderColor,
  fontFamily,
  width,
  height,
  isLoading,
  isDisabled,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Button
      sx={{
        background    : theme.palette.primary.white,
        color         : color ?? theme.palette.primary.fuchsia75,
        border        : '1px solid',
        borderColor   : borderColor ?? theme.palette.primary.fuchsia75,
        borderRadius  : 2,
        padding       : '10px',
        width         : width ?? 295,
        // height: height ?? '100%',
        fontWeight    : 'bold',
        fontFamily    : fontFamily ?? 'Montserrat',
        textTransform : 'none',
        '&: hover'    : {
          background : theme.palette.primary.white,
        },
      }}
      onClick={onClickHandler}
      disabled={isDisabled}
      {...rest}>
      {text}{' '}
      {isLoading && (
        <CircularProgress
          data-testid='outline-button-spinner' sx={{ marginLeft: 1 }} color='inherit' size={20}
        />
      )}
    </Button>
  );
};
OutlineButton.propTypes = {
  text           : PropTypes.string.isRequired,
  onClickHandler : PropTypes.func,
};
